import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ToolsService} from "../../services/toolsService/tools.service";
import {Item} from "../../models/Item";
import {ObjectConfig} from "../../models/ObjectConfig";
import {Subscription} from "rxjs";
import {itemFactory} from "../../classes/itemFactory";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-next-sibling-component',
  templateUrl: './next-sibling-component.component.html',
  styleUrls: ['./next-sibling-component.component.scss']
})
export class NextSiblingComponentComponent implements OnInit, OnDestroy {

  @Input() item:Item;
  @Input() itemList:Item[];
  public currentTool = null;
  public selectedTool = null;
  public Yiit = Yiit;
  public isOpened = false;
  public currentToolMsg:string = '';
  public isViewOnly = isViewMode || isViewModeByShareLink;
  private subscription: Subscription;
  constructor(private toolsAdapter: ToolsService, private cd: ChangeDetectorRef, private itemFactory: itemFactory) { }

  ngOnInit() {
    this.currentTool = this.item.config.getTool();
    this.selectedTool = this.item.config.getTool();
    this.subscription = new Subscription();

    this.currentToolMsg = (this.currentTool && this.currentTool.category) ? `Change ${this.currentTool.category.name}  type` : '';

    this.subscription.add(this.item.config.subject.subscribe(()=>{
      this.cd.detectChanges();
    }));

    this.item.getObservable(Item.APPLY_NEW_TOOL).subscribe((tool)=>{
      this.setNewConfigToItem(tool, true);
    })
  }

  ngOnDestroy(): void {
    this.cd.detach();
    this.subscription.unsubscribe();
  }

  isEnabled() {
    return (window.hasOwnProperty('TOOL_CHANGE_ALLOWED') && window['TOOL_CHANGE_ALLOWED']);
  }

  getSiblingTools(){
    if (this.item.config.getTool() && this.item.config.getTool().category){
      let toolType = this.item.config.getTool().type;
      let list = this.toolsAdapter.getToolsInCategory(this.item.config.getTool().category).filter((tool:any)=>{return tool.type == toolType});
      list.sort((toolA, toolB) => {
        if (toolA.position > toolB.position) { return 1; }
        if (toolA.position < toolB.position) { return -1; }
        if (toolA.id > toolB.id) { return 1; }
        if (toolA.id < toolB.id) { return -1; }
        return 0;
      });
      return list;
    }
    return [];
  }

  toggleOpenStatus(){
    if (this.isViewOnly) { return; }
    this.isOpened = !this.isOpened;
  }

  setNewConfigToItem(tool, notEmitSwitch?){
    let newTool = Object.assign({}, tool);
    this.toolsAdapter.assignMappings(newTool);
    if (this.currentTool.name != this.item.config.getTitle()){
      newTool.name = this.item.config.getTitle();
    }

    let object = {
      tool: newTool,
      position: this.getItemPositionByType(),
      rotation: this.item.config.getRotation()
    };

    const inputValues = JSON.parse(JSON.stringify(this.item.config.getInputs()));

    let newItemCopy = this.getModelItemConfigByTool(object, inputValues);
    newItemCopy.id = this.item.config.getId();

    // let config = this.getModelItemConfigByTool(newTool, this.item.config.getObjectConfig().getCenterPosition());
    this.item.config.assignWithSave(newItemCopy);
    if (!notEmitSwitch){
      this.item.getObservable('toolSwitched').next(newTool);
    }
    this.selectedTool = tool;
    this.currentTool = this.selectedTool;
    this.isOpened = false;
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }


  private getModelItemConfigByTool(object, inputValues?){

    let tool = object.tool;
    let position = object.position;
    let rotation = object.rotation;
    let fixedSize = {fixed_height: null, fixed_width: null, fixed_width_px: null};

    const getColor = (fieldName: string) => {
      const defColor = tool.default_color.toString().trim();
      const requiredColor = (tool[fieldName]) ? tool[fieldName].toString().trim() : '';
      return requiredColor.length > 0
        ? requiredColor
        : defColor.length > 0
          ? defColor
          : '#000000';
    };

    if (tool.params){
      if (tool.params.hasOwnProperty('fixedHeight')){
        fixedSize.fixed_height = tool.params['fixedHeight'].value;
      }
      if (tool.params.hasOwnProperty('fixedWidth')){
        fixedSize.fixed_width = tool.params['fixedWidth'].value;
      }
      if (tool.params.hasOwnProperty('fixedWidthPx')){
        fixedSize.fixed_width_px = tool.params['fixedWidthPx'].value;
      }
    }

    let inputs = JSON.parse(JSON.stringify(tool.params));
    if (!inputs){
      inputs = {};
    }
    if (inputValues) {
      for (const i in inputValues) {
        //&& !inputValues[i].hasOwnProperty('calculation')
        if (inputValues && inputValues.hasOwnProperty(i)) {
          if (inputs.hasOwnProperty(i) && inputValues[i].hasOwnProperty('value')) {
            inputs[i].value = inputValues[i].value;
          } else {
            inputs[i] = inputValues[i];
          }
        }
      }
    }

    let _preparedItem = {

      id: null,
      group: tool.category.name,
      title: tool.name,
      originalTitle: tool.name,
      toolId: tool.id,
      copyOf: this.item.config.getCopyParentId,
      copyDirection: this.item.config.copyDirection,
      copyGapInMeters: this.item.config.copyGapInMeters,
      creator: window['PROFILE']['name'],
      creatorEmail: window['PROFILE']['email'],
      createdAt: Math.round(Date.now() / 1000),
      objects: [{
        area: null,
        icon: {},
        map_icon: tool.map_icon,
        latLngs: position,
        length: null,
        center: position,
        originalPosition: position,
        position: position,
        radius: position,
        rotation: rotation,
        tool_id: tool.id,
        tool_type: tool.type,
        fixed_height: fixedSize.fixed_height || tool.fixed_height_meters,
        fixed_width: fixedSize.fixed_width || tool.fixed_width_meters,
        fixed_width_px: fixedSize.fixed_width_px || (tool.params && tool.params['fixedWidthPx']) ? tool.params['fixedWidthPx'] : null,
        fillColor: getColor('fill_color'),
        fillOpacity: (tool.default_opacity.toString().trim().length > 0) ? tool.default_opacity : 1,
        strokeColor: getColor('line_color'),
        strokeWeight:  tool.hasOwnProperty('map_configs')
        && tool.map_configs.hasOwnProperty('cesium')
        && tool.map_configs.cesium.hasOwnProperty('line_width') ? tool.map_configs.cesium.line_width : tool.line_thickness || 0,
      }],
      inputs: inputs
    };
    return _preparedItem;
  }


  private getItemPositionByType(){
    if (this.item.config.getObjectConfig().getPosition()){
      return this.item.config.getObjectConfig().getPosition()
    }
    else {
      return this.item.config.getObjectConfig().getPositions();
    }
  }

}
